import _toConsumableArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//

import * as XLSX from "xlsx";
import request from "@/utils/request";
export default {
  name: "suppliers",
  props: {
    //按钮图标
    icon: {
      type: String,
      default: ""
    },
    //导出按钮名称
    buttonname: {
      type: String,
      default: ""
    },
    //导出文件名称
    contentname: {
      type: String,
      default: ""
    },
    //请求方式
    strmethod: {
      type: String,
      default: ""
    },
    //请求接口
    Interface: {
      type: String,
      default: ""
    },
    //表头
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //内容
    contents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //需要转中文的参数
    changetext: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //需要转中文的数据
    changeparameter: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    binding: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //导出的数据格式
    exportcontent: {
      type: String,
      default: ""
    },
    //导出的数据
    data: {
      type: Object,
      default: function _default() {}
    },
    //判断是否可以导出
    possibleto: {
      type: Boolean,
      default: false
    },
    //提示语
    prompt: {
      type: String,
      default: ""
    },
    whether: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      loadingbut: false
    };
  },
  watch: {},
  computed: {},
  created: function created() {},
  methods: {
    exportDatas: function exportDatas() {
      var _this = this;
      if (this.possibleto == true) {
        this.$message({
          message: this.prompt,
          type: "warning",
          duration: 1000
        });
      } else {
        this.loadingbut = true;
        request({
          url: this.Interface,
          method: this.strmethod,
          data: this.data
        }).then(function (res) {
          // 创建一个工作簿
          _this.loadingbut = false;
          var arr = [];
          arr.push(_this.headers);
          eval(_this.exportcontent).forEach(function (element, index) {
            var arrs = [];
            eval(_this.contents).forEach(function (elements, index1) {
              if (elements.t == undefined) {
                arrs.push(element[elements]);
              } else {
                var temporary = JSON.parse(JSON.stringify(elements));
                temporary.v = element[elements.v];
                if (temporary.v == null) {
                  temporary = "";
                }
                arrs.push(temporary);
              }
            });
            arr.push(arrs);
            // console.log(arr, "2");
          });
          if (_this.changetext.length != 0) {
            var determine = [];
            arr[0].forEach(function (element, index) {
              _this.changetext.forEach(function (elements) {
                if (element == elements) {
                  determine.push(index);
                }
              });
            });
            arr.forEach(function (element) {
              determine.forEach(function (elements, indexs) {
                var temporarys = _this.binding[indexs];
                _this.changeparameter[indexs].filter(function (o) {
                  if (o[temporarys[0]] == element[elements]) {
                    element[elements] = o[temporarys[1]];
                  }
                });
              });
            });
          }
          console.log(arr, "arr");
          // 创建一个工作表
          var worksheet = XLSX.utils.aoa_to_sheet(arr);
          // 自适应列宽
          var columnWidths = arr.map(function (row) {
            return row.map(function (cell) {
              if (typeof cell === "string") {
                return cell.length + 8;
              } else if (typeof cell === "number" && cell.t == "n") {
                return cell.toString().length;
              } else {
                return 22; // 默认宽度为10
              }
            });
          });
          var widths = columnWidths[0].map(function (_, colIndex) {
            return Math.max.apply(Math, _toConsumableArray(columnWidths.map(function (row) {
              return row[colIndex];
            })));
          });
          worksheet["!cols"] = widths.map(function (width) {
            return {
              width: width
            };
          });
          var workbook = XLSX.utils.book_new();
          // 将工作表添加到工作簿中
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // 导出Excel文件，并指定文件名
          XLSX.writeFile(workbook, _this.contentname + ".xlsx");
        }).catch(function () {
          _this.loadingbut = false;
        });
      }
    },
    setSheetColumnWidths: function setSheetColumnWidths(sheet, columnWidths) {
      for (var i = 0; i < columnWidths.length; i++) {
        var columnWidth = columnWidths[i];
        var column = XLSX.utils.encode_col(i);
        sheet["!cols"] = sheet["!cols"] || [];
        sheet["!cols"].push({
          wch: columnWidth
        });
      }
    },
    calculateColumnWidths: function calculateColumnWidths(data) {
      // 计算列宽的逻辑，根据实际需求进行调整
      // 返回一个包含每列宽度的数组
      // 例如：[10, 15, 20] 表示第一列宽度为10，第二列宽度为15，第三列宽度为20
      // 可以根据实际需求进行计算
      // return [10, 15, 20];
      var columnWidths = [];
      for (var i = 0; i < data[0].length; i++) {
        var maxLength = 0;
        for (var j = 0; j < data.length; j++) {
          var cellValue = data[j][i];
          var cellWidth = this.measureTextWidth(cellValue);
          maxLength = Math.max(maxLength, cellWidth);
        }
        columnWidths.push(maxLength);
      }
      return columnWidths;
    },
    measureTextWidth: function measureTextWidth(text) {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      context.font = "12px Arial"; // 设置字体样式和大小
      var metrics = context.measureText(text);
      return metrics.width - 50;
    }
  }
};